// Function to calculate the spotlight position
export function projectedComponentIdLive(mediaId:number, pageNumber:number):string {
	// Implementation goes here
	// ...
	return `projected-live-${mediaId}-${pageNumber}`;
}

export function projectedComponentIdEditing(mediaId:number, pageNumber: number):string {
	// Implementation goes here
	// ...
	return `projected-editing-${mediaId}-${pageNumber}`;
}

export function connectorIdLive(mediaId: any, pageNumber: number):string {
	// Implementation goes here
	// ...
	return `connector-live-${mediaId}-${pageNumber}`;
}

export function connectorIdEditing(mediaId: any, pageNumber: number):string {
	// Implementation goes here
	// ...
	return `connector-editing-${mediaId}-${pageNumber}`;
}
